import React from 'react'
import { observer } from 'mobx-react'

import './derived.scss'

const LMXChartSlot = ({ store, position, chartKey }) => {
    const slide = store.activeSlide
    const question = slide.question.get(position)
    const data = store.getChartDataForQuestion(`${question.surveyId}-LMX`, position)

    return (
        <div className="pp-derived-slot">
            {question
                ? store.getChart(
                    {
                        ...data,
                        title: '',
                        containerSize: { height: 400, width: 450 },
                        chartType: 'lmx',
                        kpiType: 'LMX',
                        surveyId: question.surveyId,
                        settings: question.settings,
                        key: chartKey,
                    },
                    data?.data,
                    [...question.comparisonYears, question.year],
                )
                : null}
        </div>
    )
}

export default observer(LMXChartSlot)
